var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.41 7.49c-4.66-4.63-12.19-4.61-16.83.05-3.78 3.8-4.55 9.65-1.89 14.3L4 28l6.3-1.65c1.74.95 3.7 1.45 5.68 1.45 6.59 0 11.94-5.31 12.01-11.89-.03-3.17-1.33-6.2-3.59-8.41ZM16 25.79c-1.77 0-3.51-.47-5.04-1.38l-.36-.21-3.74.98 1-3.65-.24-.38c-2.83-4.68-1.33-10.76 3.35-13.59s10.76-1.33 13.59 3.35a9.99 9.99 0 0 1 1.43 4.99c-.06 5.48-4.52 9.89-10 9.89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.42 18.39c-.3-.15-1.76-.87-2.03-.96s-.47-.15-.67.15c-.2.3-.77.96-.94 1.17s-.35.23-.64.08a8.092 8.092 0 0 1-4.05-3.54c-.31-.52.31-.49.87-1.62.08-.17.07-.36-.03-.52-.07-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51s-.37-.01-.57-.01c-.3 0-.59.14-.79.37-.68.64-1.06 1.54-1.04 2.48.1 1.12.52 2.19 1.21 3.07 1.28 1.91 3.03 3.46 5.08 4.49 1.89.81 2.62.88 3.57.75a3.03 3.03 0 0 0 2-1.41c.19-.44.25-.94.17-1.41-.06-.14-.26-.21-.56-.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.13d2ff4ce3bb7373d0ed0be8ae41d600.svg";
export { ForwardRef as ReactComponent };